import { render } from "./AddParentPage.vue?vue&type=template&id=02920a7b&ts=true"
import script from "./AddParentPage.vue?vue&type=script&lang=ts"
export * from "./AddParentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__